module.exports = __webpack_public_path__ + "img/higgs_module_content2_3_right.ebe0c98f.png";